import { render, staticRenderFns } from "./dialog-table-diretrizes.vue?vue&type=template&id=a46b381c&scoped=true&"
import script from "./dialog-table-diretrizes.vue?vue&type=script&lang=js&"
export * from "./dialog-table-diretrizes.vue?vue&type=script&lang=js&"
import style0 from "./dialog-table-diretrizes.vue?vue&type=style&index=0&id=a46b381c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46b381c",
  null
  
)

export default component.exports